import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { AiChatPopupComponent } from './ai-chat-popup/ai-chat-popup.component';
import { AiChatIdentityService } from './services/ai-chat-identity.service';
import { AiChatPanelService } from './services/ai-chat-panel.service';
import { AiChatThreadService } from './services/ai-chat-thread.service';

/**
 * Layout-hosted AI Assistant host: FAB + always-mounted popup (hidden when closed so
 * in-flight streams and local message state survive minimize).
 */
@Component({
    selector: 'acm-ai-chat-shell',
    imports: [MatIcon, AiChatPopupComponent],
    templateUrl: './ai-chat-shell.component.html',
    styleUrl: './ai-chat-shell.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiChatShellComponent {
    protected readonly panel = inject(AiChatPanelService);

    constructor() {
        inject(AiChatIdentityService);
        void inject(AiChatThreadService).refreshThreads();
    }
}
